// Common flagged words/phrases that should trigger moderation
export const FLAGGED_WORDS = [
  'spam',
  'scam',
  'hack',
  'cheat',
  'illegal',
  'violence',
  'harassment',
  'abuse',
  'hate speech',
  'discrimination',
  // Add more as needed
]

export const checkForFlaggedWords = (text: string): { hasFlagged: boolean; flaggedWords: string[] } => {
  const lowerText = text.toLowerCase()
  const found: string[] = []

  FLAGGED_WORDS.forEach(word => {
    if (lowerText.includes(word.toLowerCase())) {
      found.push(word)
    }
  })

  return {
    hasFlagged: found.length > 0,
    flaggedWords: found,
  }
}

export const logFlaggedContent = (
  contentId: string,
  content: string,
  authorId: string,
  authorUsername: string,
  flaggedWords: string[]
) => {
  const logEntry = {
    id: `flag_${Date.now()}`,
    contentId,
    content,
    authorId,
    authorUsername,
    flaggedWords,
    timestamp: new Date().toISOString(),
    resolved: false,
  }

  let existingLogs: any[] = []
  try {
    existingLogs = JSON.parse(localStorage.getItem('flagged_content_log') || '[]')
  } catch (e) {
    console.error('Error reading flagged content log:', e)
  }
  existingLogs.push(logEntry)
  localStorage.setItem('flagged_content_log', JSON.stringify(existingLogs))

  return logEntry
}

export const getFlaggedContentLog = () => {
  try {
    const logs = localStorage.getItem('flagged_content_log')
    return logs ? JSON.parse(logs) : []
  } catch (e) {
    console.error('Error reading flagged content log:', e)
    return []
  }
}

export const markFlaggedAsResolved = (logId: string) => {
  const logs = getFlaggedContentLog()
  const updated = logs.map((log: any) =>
    log.id === logId ? { ...log, resolved: true } : log
  )
  localStorage.setItem('flagged_content_log', JSON.stringify(updated))
}

